import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";
import apiInstanceInternal from "config/axiosInstanceInternal";
import { toast } from "react-toastify";

// const { viewEligibility, viewPayerReq, viewPayerRes } = useSelector(
//   (state) => state.preauthorization
// );

// const viewEligibilityLink = getPathFromUrl(viewEligibility);

export const GetAllPreauthorizationType = createAsyncThunk(
  "preauthorization/GetAllPreauthorizationType",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("claimtypeList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllPreauthorizationStatus = createAsyncThunk(
  "preauthorization/GetAllPreauthorizationStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("allstatusList", {
        status_type: "preauthorization",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllPreauthorizationList = createAsyncThunk(
  "preauthorization/GetAllPreauthorizationList",
  async (body) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationList",
        body
      );
      return response.data;
    } catch (error) {
      // return rejectWithValue(error.response?.data || "Something went wrong");
      toast.error("Something went wrong");
    }
  }
);

export const GetAllClaimPreAuthAllList = createAsyncThunk(
  "preauthorization/ClaimPreAuthAllList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("claimpreauthallList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllNationality = createAsyncThunk(
  "preauthorization/GetAllNationality",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("nationalityList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllPractitonerList = createAsyncThunk(
  "preauthorization/GetAllPractitonerList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("practitionerList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetSpecialityPractitonerList = createAsyncThunk(
  "preauthorization/GetSpecialityPractitonerList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("practitionerspltyList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetServiceCodeDescription = createAsyncThunk(
  "preauthorization/GetServiceCodeDescription",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("diagcodeSearch", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetMorphologyCodeDescription = createAsyncThunk(
  "preauthorization/GetMorphologyCodeDescription",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("morphcodeSearch", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllServiceCodeDescription = createAsyncThunk(
  "preauthorization/GetAllServiceCodeDescription",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("prodservSearch", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllSpecilaity = createAsyncThunk(
  "preauthorization/GetAllSpecilaity",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("specilaityList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllSnowedCodeDescription = createAsyncThunk(
  "preauthorization/GetAllSnowedCodeDescription",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("snomedcodeSearch", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllTriagoCountry = createAsyncThunk(
  "preauthorization/GetAllTriagoCountry",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("enctalltypeList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllEncounterInfo = createAsyncThunk(
  "preauthorization/GetAllEncounterInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("enctalltypeList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllProviderName = createAsyncThunk(
  "preauthorization/GetAllProviderName",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("nphiesprovdrSearch", {
        nphprov_id: "1000000000",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllEncounterClass = createAsyncThunk(
  "preauthorization/GetAllEncounterClass",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("enctclsSearch");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllBodySite = createAsyncThunk(
  "preauthorization/GetAllBodySite",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("bodysiteSearch");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetSearchLabCode = createAsyncThunk(
  "preauthorization/GetSearchLabCode",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("labcodeSearch", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllRoute = createAsyncThunk(
  "preauthorization/GetAllRoute",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("pharmrouteadmin");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ViewPreauthorization = createAsyncThunk(
  "preauthorization/ViewPreauthorization",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationStatus",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetPreauthorizationEligibility = createAsyncThunk(
  "preauthorization/GetPreauthorizationEligibility",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetPreauthorizationRequest = createAsyncThunk(
  "preauthorization/GetPreauthorizationRequest",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetPreauthorizationResponse = createAsyncThunk(
  "preauthorization/GetPreauthorizationResponse",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetPreauthorizationCancelResponse = createAsyncThunk(
  "preauthorization/GetPreauthorizationCancelResponse",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetItemError = createAsyncThunk(
  "preauthorization/GetItemError",
  async (body, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("errorcodeSearch", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetMissingTooth = createAsyncThunk(
  "preauthorization/GetMissingTooth",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("missingtoothList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const SubmitPreauthorization = createAsyncThunk(
  "preauthorization/SubmitPreauthorization",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationCreate",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CancelPreauthorization = createAsyncThunk(
  "preauthorization/CancelPreauthorization",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationCancel",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const DownloadRequestJSON = createAsyncThunk(
  "preauthorization/CancelPreauthorization",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationreqDownload",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const DownloadResponseJSON = createAsyncThunk(
  "preauthorization/CancelPreauthorization",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationrespDownload",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ReUseWithoutEdit = createAsyncThunk(
  "preauthorization/ReUseWithoutEdit",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationreSubmit",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CheckPreauthorizationStatus = createAsyncThunk(
  "preauthorization/CheckPreauthorizationStatus",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/statusCheckCreate",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const SubmitSecondResponse = createAsyncThunk(
  "preauthorization/SubmitSecondResponse",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationsecResponse",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetHistoryLogs = createAsyncThunk(
  "preauthorization/GetHistoryLogs",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationHistory",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const SendCommunicationMessage = createAsyncThunk(
  "preauthorization/SendCommunicationMessage",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/communicationpreauthCreate",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllCommunicationHistory = createAsyncThunk(
  "preauthorization/GetAllCommunicationHistory",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/communicationpreauthList",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ViewPreauthorizationHistoryLog = createAsyncThunk(
  "preauthorization/ViewPreauthorizationHistoryLog",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationhistoryView",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
